import { render, staticRenderFns } from "./ColorBox.vue?vue&type=template&id=f0427328&scoped=true&"
import script from "./ColorBox.vue?vue&type=script&lang=js&"
export * from "./ColorBox.vue?vue&type=script&lang=js&"
import style0 from "./ColorBox.vue?vue&type=style&index=0&id=f0427328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0427328",
  null
  
)

export default component.exports